import { render, staticRenderFns } from "./NavigationWrapper.vue?vue&type=template&id=66ceb2ee&scoped=true&"
import script from "./NavigationWrapper.vue?vue&type=script&setup=true&lang=js&"
export * from "./NavigationWrapper.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./NavigationWrapper.vue?vue&type=style&index=0&id=66ceb2ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ceb2ee",
  null
  
)

export default component.exports